export default __webpack_public_path__ + "static/media/4.0b1f23dc.svg";